import { Table, TableHead, TableCell, TableRow, TableBody } from "@mui/material";

const JuniorMatrix = () => {
  return (
    <div>
      <Table className="matrix-table">
        <TableHead>
          <TableCell colSpan={4} align="center">
            <h4>Junior Officer Review Matrix</h4>
          </TableCell>
        </TableHead>
        <TableHead>
          <TableRow>
            <TableCell>Review</TableCell>
            <TableCell>1st Assessor</TableCell>
            <TableCell>2nd Assessor</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell className="b-600">2nd Mate</TableCell>
            <TableCell>Chief Mate</TableCell>
            <TableCell>Master</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="b-600">3rd Mate</TableCell>
            <TableCell>Chief Mate</TableCell>
            <TableCell>Master</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="b-600">2nd Assistant Engineer</TableCell>
            <TableCell>1st Assistant Engineer</TableCell>
            <TableCell>Chief Engineer</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="b-600">3rd Assistant Engineer</TableCell>
            <TableCell>1st Assistant Engineer</TableCell>
            <TableCell>Chief Engineer</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
};

export default JuniorMatrix;
